"use client";

import React from "react";
import FooterLinks from "./FooterLinks";
import Link from "next/link";

const Footer: React.FC = () => {
  return (
    <div>
      <footer className="ftco-footer ftco-bg-dark ftco-section">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-2">
              <div className="ftco-footer-widget mb-7">
                <h2 className="ftco-heading-2">
                  <p className="ski-chalet-link">Inspiration</p>
                </h2>
                <ul className="list-unstyled">
                  {[
                    {
                      href: "/ShortTransfer",
                      label: "Resorts with Short Airport Transfers",
                    },
                    {
                      href: "/ChristmasSki",
                      label: "Resorts for a Christmas Ski",
                    },
                    {
                      href: "/NewYearSki",
                      label: "Resorts for a New Year Ski",
                    },
                    { href: "/EasterSki", label: "Resorts for an Easter Ski" },
                    {
                      href: "/HalfTermSki",
                      label: "Resorts for a Half-Term Ski",
                    },
                    {
                      href: "/EarlySeasonSki",
                      label: "Resorts for an Early Season Ski",
                    },
                    {
                      href: "/LateSeasonSki",
                      label: "Resorts for a Late Season Ski",
                    },
                    {
                      href: "/CloseToCalais",
                      label: "Resorts closer to Calais",
                    },
                    {
                      href: "/FamilyFriendly",
                      label: "Family Friendly Resorts",
                    },
                    {
                      href: "/ScenicViews",
                      label: "Resorts with Scenic Views",
                    },
                    {
                      href: "/LargeSkiingArea",
                      label: "Resorts with a large Skiing Area",
                    },
                    {
                      href: "/GoodOffPiste",
                      label: "Resorts known for Off-Piste",
                    },
                  ].map(({ href, label }) => (
                    <li key={href}>
                      <a
                        href={href}
                        className="py-2 d-block"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-md-2">
              <div className="ftco-footer-widget mb-7">
                <h2 className="ftco-heading-2">
                  <p className="ski-chalet-link">Blog Articles</p>
                </h2>
                <ul className="list-unstyled">
                  <li>
                    <a
                      href="/Skiing-at-Christmas"
                      className="py-2 d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Skiing at Christmas - where to go
                    </a>
                  </li>
                  <li>
                    <a
                      href="/Chalets-in-Austria"
                      className="py-2 d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Chalets in Austria
                    </a>
                  </li>
                  <li>
                    <a
                      href="/Chalets-in-Chamonix"
                      className="py-2 d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Chalets in Chamonix
                    </a>
                  </li>
                  <li>
                    <a
                      href="/Chalets-in-St-Anton"
                      className="py-2 d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Chalets in St Anton
                    </a>
                  </li>

                  <li>
                    <a
                      href="/alpe-d-huez-christmas"
                      className="py-2 d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Alpe d&apos;Huez at Christmas
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <FooterLinks />
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="ftco-footer-widget mb-3">
                <h2 className="ftco-heading-2">ChaletAway</h2>
                <p>
                  Here at ChaletAway, our aim is to help you to spend more time
                  on the slopes in the places that suit you...
                </p>
                <Link href="/Privacy" className="py-2 d-block">
                  Privacy Policy
                </Link>
                <Link href="/sitemap.xml" className="py-2 d-block">
                  Sitemap
                </Link>
              </div>
            </div>

            <div className="col-md-4">
              <div className="ftco-footer-widget mb-3">
                <h2 className="ftco-heading-2">Contact Information</h2>
                <ul className="list-unstyled">
                  <li>
                    <Link
                      href="mailto:Hello@ChaletAway.co.uk"
                      className="py-2 d-block"
                    >
                      Hello@ChaletAway.co.uk
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-4">
              <div className="ftco-footer-widget mb-3">
                <ul className="ftco-footer-social list-unstyled float-md-right float-lft">
                  <li className="ftco-animate">
                    <Link
                      href="mailto:Hello@ChaletAway.co.uk"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fas fa-at fa-2x"></i>
                    </Link>
                  </li>
                  <li className="ftco-animate">
                    <Link
                      href="https://twitter.com/Huttetravel"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-twitter fa-2x"></i>
                    </Link>
                  </li>
                  <li className="ftco-animate">
                    <Link
                      href="https://www.instagram.com/HutteTravel"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-instagram fa-2x"></i>
                    </Link>
                  </li>
                  <li className="ftco-animate">
                    <Link
                      href="https://www.facebook.com/HutteTravel/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-facebook-f fa-2x"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 text-center">
              <p>
                Copyright © {new Date().getFullYear()} All rights reserved
                ChaletAway
              </p>
            </div>
          </div>
        </div>
      </footer>
      {/* 
      <div id="ftco-loader" className="show fullscreen">
        <svg className="circular" width="48px" height="48px">
          <circle
            className="path-bg"
            cx="24"
            cy="24"
            r="22"
            fill="none"
            strokeWidth="4"
            stroke="#eeeeee"
          />
          <circle
            className="path"
            cx="24"
            cy="24"
            r="22"
            fill="none"
            strokeWidth="4"
            strokeMiterlimit={10}
            stroke="#F96D00"
          />
        </svg>
      </div> */}
    </div>
  );
};

export default Footer;
